import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router';

export const withRouter = (WrappedComponent) =>
    function WithRouterWrapper(props) {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();

        const history = {
            push: navigate,
            location,
            back: () => navigate(-1),
            goBack: () => navigate(-1),
            state: location.state,
        };

        return <WrappedComponent {...props} history={history} location={location} match={{ params }} />;
    };
